<script>
    import Vue from 'vue'
    import axios from 'axios';
    import MyCookie from './MyCookie.vue'

    Vue.mixin(MyCookie);

    export default {
        data() {
            return {
                initLoading: false,
            };
        },
        methods: {
            // 連続でpostする場合は、setLoadingStatus:falseの方がよい
            axios_post(url, data) {
                this.$store.commit('common_store/setLoading', true);
                console.log(url);

                let token = this.getCookie("Token");
                console.log(token);


                const http = axios.create();
                http.interceptors.request.use((config) => {
                    if (token) {
                        config.headers.Authorization = `Bearer ${token}`
                        return config
                    }
                    return config
                });

                const my_axios = http.post(url, data);

                return new Promise((resolve, reject) => {
                    my_axios.then((res) => {
                        this.$store.commit('common_store/setLoading', false);
                        console.log(res);
                        resolve(res);
                    });
                    my_axios.catch((err) => {
                        this.$store.commit('common_store/setLoading', false);
                        console.log(err);
                        if (err.response.status.toString() === "401") {
                            alert("認証エラー ログイン画面に戻ります");
                            window.location.href = "/login_pc.html";
                        }
                        reject(err);
                    });
                });
            },
            axios_post_noloading(url, data) {
                const myAxios = axios.post(url, data);

                return new Promise((resolve, reject) => {
                    myAxios.then((res) => {
                        resolve(res);
                    });
                    myAxios.catch((err) => {
                        console.log(err);
                        reject(err);
                    });
                });
            },
        },
    };
</script>
